/**
 * import axios for server calls
 */
import axios from 'axios';
import React from 'react';
import { useState } from "react";
/**
 * @param contact = contact id
 * @param eventid = event id
 */
function EventContact ({contact, eventid}) {
    const [hasRsvped, setHasRsvped] = useState(false);
    checkRsvp();
    
   /**
    * function checkRsvp()
    * checks if a contact has rsvp to a certain event
    * if true will display check mark
    * if false will no display check mark
    */
    async function checkRsvp() {
    
    const rsvpCheck = {
        contactId:  contact._id,
        eventId: eventid
    }
   
    const rsvped = await axios.post("https://link2rsvp.herokuapp.com/contact/rsvped", rsvpCheck);
    
    if (rsvped.data === "true")
        setHasRsvped(true);
    else 
        setHasRsvped(false);
        //getEventContacts();
}

    return (
        <div>
            <span>
                {contact.name} {hasRsvped && (
                            <span>&#10003;</span>
                )}
            </span>
        </div>
    );
}

export default EventContact;